import { render, staticRenderFns } from "./CloseRepair.vue?vue&type=template&id=dafedb0c&scoped=true&"
import script from "./CloseRepair.vue?vue&type=script&lang=ts&"
export * from "./CloseRepair.vue?vue&type=script&lang=ts&"
import style0 from "./CloseRepair.vue?vue&type=style&index=0&id=dafedb0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafedb0c",
  null
  
)

export default component.exports